import script from "./ElencoRilevazioni.vue?vue&type=script&setup=true&lang=js"
export * from "./ElencoRilevazioni.vue?vue&type=script&setup=true&lang=js"

import "./ElencoRilevazioni.vue?vue&type=style&index=0&id=1db6f0a5&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db6f0a5"]])

export default __exports__